module.exports = __webpack_public_path__ + "img/icon_multimedia.7c1b5623.svg";